import { Route, Routes, RouteProps, Navigate } from 'react-router-dom'
import ProfileRoutes from './ProfileRoutes'
import { Loader, NotFoundPage } from 'components/ui'
import HomeRoutes from './HomeRoutes'
import InvoicesRoutes from './InvoicesRoutes'
import DocumentsRoutes from './DocumentsRoutes'
import DebtorsRoutes from './DebtorsRoutes'
import ProtectedRoute from './ProtectedRoute'
import UploadDocsRoutes from './UploadDocsRoutes'
import ReportsRoutes from './ReportsRoutes'
import DashboardRoutes from './DashboardRoutes'
import usePermissions from 'hooks/usePermissions'

export const DASHBOARD_PATH = '/dashboard'
export const HOME_PATH = '/home'
export const DEFAULT_PATH = '/'

type ApplicationRouteProps = RouteProps & {
  isAuth: boolean
}

const ApplicationRoute = (props: ApplicationRouteProps) => {
  const { isAuth } = props
  const { canReadDashboard, isPermissionsLoaded } = usePermissions()
  const initialPath = canReadDashboard ? DASHBOARD_PATH : HOME_PATH

  return (
    <Routes>
      <Route
        path="/profile/*"
        element={
          <ProtectedRoute isAuth={isAuth}>
            <ProfileRoutes />
          </ProtectedRoute>
        }
      />
      <Route
        path="/home/*"
        element={
          <ProtectedRoute isAuth={isAuth}>
            <HomeRoutes />
          </ProtectedRoute>
        }
      />
      <Route
        path="/invoices/*"
        element={
          <ProtectedRoute isAuth={isAuth}>
            <InvoicesRoutes />
          </ProtectedRoute>
        }
      />
      <Route
        path="/debtors/*"
        element={
          <ProtectedRoute isAuth={isAuth}>
            <DebtorsRoutes />
          </ProtectedRoute>
        }
      />
      <Route
        path="/upload/*"
        element={
          <ProtectedRoute isAuth={isAuth}>
            <UploadDocsRoutes />
          </ProtectedRoute>
        }
      />
      <Route
        path="/documents/*"
        element={
          <ProtectedRoute isAuth={isAuth}>
            <DocumentsRoutes />
          </ProtectedRoute>
        }
      />
      <Route
        path="/reports/*"
        element={
          <ProtectedRoute isAuth={isAuth}>
            <ReportsRoutes />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/*"
        element={
          <ProtectedRoute isAuth={isAuth}>
            <DashboardRoutes />
          </ProtectedRoute>
        }
      />
      <Route
        path="/"
        element={isPermissionsLoaded ? <Navigate to={initialPath} replace /> : <Loader type="default" loading={true} />}
      />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}

export default ApplicationRoute
